/* eslint-disable */
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";

import apiSlice from "../api/apiSlice";
import { effectiveAtQuery, withBusinessValidity } from "../../utils/businessValidity";

const ownershipsAdapter = createEntityAdapter({});

// It will use the communityAdapter automatic formatted data
const initialState = ownershipsAdapter.getInitialState({});

export const ownershipsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getOwnershipsByMemberId: builder.query({
      query: ({ communityId, memberId }) => ({
        url: `/communities/${communityId}/ownerships/${memberId}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [{ type: "Member", id: arg.memberId }],
    }),
    /* POST */
    addOwnershipByMemberIdResourceId: builder.mutation({
      query: ({ memberId, resourceId, percOwnership, communityId, start_date, end_date }) => {
        return {
          url: `/communities/${communityId}/ownerships/${memberId}/${resourceId}`,
          method: "POST",
          validateStatus: (response, result) => {
            return response.status === 201 && !result.isError;
          },
          body: withBusinessValidity({
            member_id: memberId,
            resource_id: resourceId,
            perc_ownership: percOwnership,
            start_date,
            end_date,
          }),
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: "Member", id: arg.memberId },
        { type: "Resource", id: arg.resourceId },
      ],
    }),
    /* UPDATE */
    updateOwnershipByMemberIdResourceId: builder.mutation({
      query: ({ communityId, memberId, resourceId, percOwnership, start_date, end_date }) => ({
        url: `/communities/${communityId}/ownerships/${memberId}/${resourceId}`,
        method: "PUT",
        body: withBusinessValidity({
          perc_ownership: percOwnership,
          start_date,
          end_date,
        }),
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Member", id: arg.memberId },
        { type: "Resource", id: arg.resourceId },
      ],
    }),
    /* DELETE */
    deleteOwnershipByMemberIdResourceId: builder.mutation({
      query: ({ communityId, memberId, resourceId, effectiveAt }) => ({
        url: `/communities/${communityId}/ownerships/${memberId}/${resourceId}?${effectiveAtQuery(
          effectiveAt
        )}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Member", id: arg.memberId },
        { type: "Resource", id: arg.resourceId },
      ],
    }),
  }),
});

export const {
  useGetOwnershipsByMemberIdQuery,
  useAddOwnershipByMemberIdResourceIdMutation,
  useUpdateOwnershipByMemberIdResourceIdMutation,
  useDeleteOwnershipByMemberIdResourceIdMutation,
} = ownershipsApiSlice;

// Define function to get selectors based on arguments (members_id) of getOwnershipsByMemberId
export const getSelectorsByMemberId = (member_id) => {
  const selectOwnershipsResult =
    ownershipsApiSlice.endpoints.getOwnershipsByMemberId.select(member_id);

  const selectOwnershipsData = createSelector(selectOwnershipsResult, (ownershipsResult) =>
    ownershipsAdapter.getSelectors(() => ownershipsResult?.data ?? initialState)
  );
  return {
    selectAll: createSelector(selectOwnershipsData, (s) => s.selectAll(undefined)),
    selectEntities: createSelector(selectOwnershipsData, (s) => s.selectEntities(undefined)),
    selectIds: createSelector(selectOwnershipsData, (s) => s.selectIds(undefined)),
    selectTotal: createSelector(selectOwnershipsData, (s) => s.selectTotal(undefined)),
    selectById: (id) => createSelector(selectOwnershipsData, (s) => s.selectById(s, id)),
  };
};
